import React from 'react';
import { Spinner } from 'react-bootstrap';
import PropTypes from 'prop-types';

const SubmitButton = ({
  onClick,
  isLoading,
  label = 'Submit',
  className = '',
  style = {},
  disabled = false,
}) => {
  return (
    <div className="position-relative">
      <button
        type="button"
        onClick={onClick}
        style={{ height: '40px', fontSize: '13px', ...style }}
        className={`w-100 btn1 btn-primary1 cursor-pointer rounded fw_500 px-4 ${className}`}
        disabled={disabled || isLoading}
      >
        {isLoading ? (
          <>
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              className="me-2"
            />
            Processing...
          </>
        ) : (
          label
        )}
      </button>
    </div>
  );
};

SubmitButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  label: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  disabled: PropTypes.bool,
};

export default SubmitButton;
